const buttonVariants = () => {
    return {
        hover: {
            scale: [1.1, 1, 1.1, 1, 1.1, 1, 1.1, 1, 1.1, 1], 
            boxShadow: "0px 2px 10px #fff",
         }
    }
}

export default buttonVariants